import React, { useEffect, useMemo, useRef, useState } from "react";
import Navbar from "../../../../posnavbar/Navbar";
import { Box, Button, selectClasses } from "@mui/material";
import Grid from "@mui/material/Grid";
import "./CreateMenuForm.css";
import {
  filterCategory,
  productCreation,
  updateRestaurantMenu,
  productCreationIMS,
  uploadImageBase64,
} from "../../../../../../config/Services";
import StyledSelect from "../../../all-products/components/custom/StyledSelect";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { useNavigate, useLocation } from "react-router-dom";
import itemNameIcon from "../../../../../../assets/images/item-name-icon.png";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import coverIcon from "../../../../../../assets/images/cover-icon.png";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import cutlery from "../../../../../../assets/images/cutlery.png";
import PosCustomCheckBox from "../../../../../../customComponents/PosCustomCheckBox/PosCustomCheckBox";
import rupeesIcon from "../../../../../../assets/images/rupees-icon.png";
import { PosCustomRadioButton } from "../../../../../../customComponents/PosCustomRadioButton/PosCustomRadioButton";
import vegan from "../../../../../../assets/images/vegan.png";
import { CodeBracketIcon } from "@heroicons/react/20/solid";
import CancelAndConfirmModal from "../../../all-products/components/CancelAndConfirmModal/CancelAndConfirmModal";

export const CreateMenuForm = () => {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  const { editData, id } = location.state || {};

  const [dietarySelected, setDietarySelected] = useState("");
  const [addOnId, setAddOnId] = useState(1);
  const [menu, setMenu] = useState([]);
  const [menuOptions, setMenuOptions] = useState([]);
  const [selectedMenuOption, setSelectedMenuOption] = useState({
    value: "",
    label: "",
  });
  const [validationError, setValidationError] = useState({});
  const [loader, setLoader] = useState(false);
  const [isVegan, setIsVegan] = useState("");
  const [uploadedImage, setImgaeUploaded] = useState("");
  const [isVeganDisplay, setIsVeganDisplay] = useState(false);
  const [cancelAndConfirmModalOpen, setCancelAndConfirmModalOpen] = useState(false);
  const [agree, setAgree] = useState(false);
  const [uploadedImageName, setUploadedImageName] = useState(false);
  const [checkedValue, setCheckedValue] = useState([]);
  const [productCreationData, setProductCreationData] = useState({
    productName: "",
    productTypes: "MENU",
    foodType: "",
    saleModes: {
      DINE_IN: { sellingPrice: "" },
      TAKE_AWAY: { sellingPrice: "" },
      DELIVERY: { sellingPrice: "" },
    },
    taxRate: { value: "", label: "" },
    cgst: "",
    sgst: "",
    specification: "",
    unitOfMeasure: { value: "piece", label: "piece" },
    taxStatus: "TAXABLE",
    veganType: "",
    images: {
      front: "",
    },
    shortCode: "",
    taxType: "INCLUSIVE",
  });

  const retailUserDetails = localStorage.getItem("retailUserDetails");
  const uidx = retailUserDetails ? JSON.parse(retailUserDetails).uidx : null;
  const userName = localStorage.getItem("user_name");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const locName = localStorage.getItem("LocName");

  //For trigger file input
  const fileInputRef = useRef(null);

  //Formatting date according to format required by API
  const now = new Date();
  const formattedDate = now.toISOString();

  //SaleModeArray
  const saleModeArr = [
    { saleMode: "DINE_IN", label: "Dine in" },
    { saleMode: "TAKE_AWAY", label: "Takeaway" },
    { saleMode: "DELIVERY", label: "Delivery" },
  ];

  //GST Options
  const gstSelectOptions = useMemo(
    () => [
      { value: 0, label: "0%" },
      { value: 5, label: "5%" },
      { value: 12, label: "12%" },
      { value: 18, label: "18%" },
      { value: 28, label: "28%" },
    ],
    []
  );

  //UOM Array
  const uomArray = useMemo(
    () => [
      { label: "gram", value: "gram" },
      { label: "kilogram", value: "kilogram" },
      { label: "milliliter", value: "milliliter" },
      { label: "litre", value: "liter" },
      { label: "piece", value: "piece" },
      { label: "ounce", value: "ounce" },
      { label: "pound", value: "pound" },
      { label: "unit", value: "unit" },
      { label: "kilocalorie", value: "kilocalorie" },
      { label: "Small", value: "Small" },
      { label: "Medium", value: "Medium" },
      { label: "Large", value: "Large" },
      { label: "Extra Large", value: "Extra Large" },
      { label: "Regular", value: "Regular" },
      { label: "Half", value: "Half" },
      { label: "Full", value: "Full" },
      { label: "Quarter", value: "Quarter" },
      { label: "Packet", value: "Packet" },
    ],
    []
  );

  //Payload
  const payload = {
    ...(editData && { productId: editData?.productId }),
    productName: productCreationData.productName,
    action: "product_create",
    logType: "Create",
    logTime: formattedDate,
    loggedBy: uidx,
    loggedByName: userName,
    sourceId: orgId,
    sourceLocationId: locId,
    sourceName: locName,
    sourceType: "Restaurant",
    product: {
      ...(editData && { id: editData?.id || "" }),
      ...(editData && { productId: editData?.productId }),
      name: productCreationData.productName,
      title: productCreationData.productName,
      appCategories: {
        categoryLevel1: [selectedMenuOption.label] || [],
        categoryLevel1Id: [selectedMenuOption.value] || [],
        categoryLevel2: [],
        categoryLevel2Id: [],
      },
      posCategories: {
        categoryLevel1: [selectedMenuOption.label] || [],
        categoryLevel1Id: [selectedMenuOption.value] || [],
        categoryLevel2: [],
        categoryLevel2Id: [],
      },
      productTypes: [productCreationData.productTypes],
      taxReference: {
        taxName: "GST & CESS",
        taxType: productCreationData?.taxType || "INCLUSIVE",
        taxCategory: "GST",
        taxRate: productCreationData.taxRate.value,
        isDefault: true,
        metadata: {
          hsnCode: "",
          cess: 0,
          cgst: productCreationData.cgst,
          sgst: productCreationData.sgst,
        },
      },
      attributes: {
        foodType: productCreationData.foodType,
        vegan: productCreationData.veganType || false,
      },
      storeSpecificData: {
        storeId: orgId,
        storeLocationId: locId,
        storeName: orgId,
        storeLocationName: locId,
      },
      variants: [
        {
          ...(editData && { variantId: editData?.variantId }),
          name: productCreationData.productName,
          recipeRequest: null,
          addOn: [],
          externalSalesChannels: checkedValue.map((saleMode) => ({
            salesChannelName: saleMode,
            deliveryConsumable: [],
            salePrice: Number(productCreationData.saleModes[saleMode].sellingPrice),
            marginPercentage: 0,
            profit: Number(productCreationData.saleModes[saleMode].sellingPrice),
          })),
          sku: "5555500081240",
          weight: productCreationData.specification,
          weightUnit: productCreationData.unitOfMeasure.value,
          taxStatus: productCreationData.taxStatus,
          minB2COrderQuantity: 1,
          minB2BOrderQuantity: 1,
          minPosOrderQuantity: 1,
          images: {
            front: uploadedImage || "",
          },
          inventorySync: {
            mrp: productCreationData.sellingPrice,
            sellingPrice: productCreationData.sellingPrice,
            purchasePrice: productCreationData.sellingPrice,
          },
          sellingUnits: [
            {
              quantity: productCreationData.specification,
              unitOfMeasure: productCreationData.unitOfMeasure.value,
            },
          ],
          weightsAndMeasures: [
            {
              measurementUnit: productCreationData.unitOfMeasure.value,
              netWeight: productCreationData.specification,
              grossWeight: productCreationData.specification,
              netContent: productCreationData.specification,
              metadata: {
                type: "PRIMARY",
              },
            },
          ],
          metadata: {
            additionalProp1: "string",
            additionalProp2: "string",
            additionalProp3: "string",
          },
          createdBy: uidx,
          createdByName: userName,
          isActive: true,
          shortCode: productCreationData.shortCode || "",
        },
      ],
      imageUrls: {
        front: uploadedImage || "",
      },
      createdBy: uidx,
      createdByName: userName,
      updatedBy: uidx,
      updatedByName: userName,
    },
  };

  //Storing Food Type
  useEffect(() => {
    setProductCreationData((prev) => ({
      ...prev,
      foodType: dietarySelected,
    }));
  }, [dietarySelected]);

  //Storing the product is vegan or not
  useEffect(() => {
    setProductCreationData((prev) => ({
      ...prev,
      veganType: isVegan === "true" ? true : isVegan === "false" ? false : "",
    }));
  }, [isVegan]);

  //Clicking the File input
  const handleFileInputClick = () => {
    fileInputRef.current.click();
  };

  //Submit Creation Menu form
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    //Object for handling different error messages
    const error = {};

    //Display Error message if category is not selected
    if (!selectedMenuOption.value && !editData) {
      error.category = "Category is required";
    }

    //Display Error message if Item name is not filled
    if (!productCreationData.productName.trim() && !editData) {
      error.ItemName = "Item name is required";
    }

    // //Display Error message if Short code is not filled
    // if (!productCreationData.shortCode.trim() && !editData) {
    //   error.shortCode = "ShortCode is required";
    // }

    if (!dietarySelected && !editData) {
      error.dietary = "Dietary Tag is required";
    }

    if (checkedValue.length === 0 && !editData) {
      error.saleMode = "At least one sale mode must be selected";
    } else {
      checkedValue.forEach((saleMode) => {
        if (!productCreationData.saleModes[saleMode].sellingPrice && !editData) {
          error[`sellingPrice_${saleMode}`] = `Item price is required`;
        }
      });
    }

    //storing errors into the state
    if (Object.keys(error).length > 0) {
      setValidationError(error);
      setLoader(false);
      return;
    }

    //clear previous error
    setValidationError({});

    const prodId = Math.floor(1000 + Math.random() * 9000);

    const addId = Math.floor(1000 + Math.random() * 9000);
    setAddOnId(addId);

    //API to create Product
    productCreation(payload)
      .then((response) => {
        const resp = response.data;
        if (resp.data.es !== 0) {
          showSnackbar(resp?.data?.message || "Unable to Create");
        }
        if (resp.status === "ERROR") {
          showSnackbar(resp?.status?.message || "Unable to Create");
        }
        if (resp.data.es === 0 && resp.data.message === "Success" && resp.data.statusCode === 200) {
          showSnackbar("Successfully Created");
          navigate(-1);

          // for ims batch creation
          const imsPayload = [
            {
              productId: resp?.data?.data?.productId,
              orgId: orgId,
              locationId: locId,
              gtin: resp?.data?.data?.variants?.[0]?.barcodes?.[0],
              category: selectedMenuOption?.label,
              subCategory: productCreationData?.foodType,
              level2Category: "",
              brand: "",
              specification: productCreationData?.specification,
              sellingUnit: productCreationData?.unitOfMeasure.value,
              manufacturer: "",
              packagingType: "standard",
              createdBy: uidx,
              sourceId: null,
              sourceName: null,
              variantId: resp?.data?.data?.variants?.[0]?.variantId,
              itemType: ["MENU"],
              restaurantBatchEnabled: true,
              createdByName: userName,
              productName: productCreationData?.productName,
              purchasePrice: null,
              sellingPrice: productCreationData?.saleModes?.DINE_IN?.sellingPrice,
              mrp: productCreationData?.saleModes?.DINE_IN?.sellingPrice,
            },
          ];

          // for batch creation in ims
          productCreationIMS(imsPayload)
            .then((response) => {
              const resp = response?.data;
              if (resp?.data?.es !== 0) {
                showSnackbar(resp?.data?.message || "Unable to Create in batch");
              }
              if (resp?.status === "ERROR") {
                showSnackbar(resp?.status?.message || "Unable to Create in batch");
              }
              if (
                resp?.data?.es === 0 &&
                resp?.data?.message === "Success" &&
                resp?.data?.statusCode === 200
              ) {
                showSnackbar("Successfully Created in batch", "success");
              }
              setLoader(false);
            })
            .catch((err) => {
              showSnackbar(err?.resp?.data?.message || "Unable To create in batch", "error");
              setLoader(false);
            });
        }
        setLoader(false);
      })
      .catch((err) => {
        showSnackbar(err?.resp?.data?.message || "Unable To create", "error");
        setLoader(false);
      });
  };

  //Handling Multiple inputs
  const handleChange = (e, saleMode) => {
    //extracting the name and value from input event
    const { name, value } = e.target;

    if (name === "sellingPrice" && saleMode) {
      setProductCreationData((prev) => ({
        ...prev,
        saleModes: {
          ...prev.saleModes,
          [saleMode]: {
            ...prev.saleModes[saleMode],
            sellingPrice: value,
          },
        },
      }));
    } else {
      //storing the value into productCreationData state
      setProductCreationData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  //Handling dropdowns
  const handleSelectChange = (e, option) => {
    //If the dropdown is menu dropdown
    if (option === "menu") {
      setSelectedMenuOption(e);
      if (e.value) {
        //Resetting error message
        setValidationError("");
      }
    }

    //If the dropdown is GST dropdown
    if (option === "gst") {
      const halfGst = e.value / 2;
      setProductCreationData((prev) => ({
        ...prev,
        taxRate: e,
        sgst: halfGst,
        cgst: halfGst,
      }));
    }

    //If the dropdown is UOM dropdown
    if (option === "uom") {
      setProductCreationData((prev) => ({
        ...prev,
        unitOfMeasure: e,
      }));
    }
  };

  //Remove prefix/suffix from the uploaded file name (.png, .jpg, etc...)
  const removeDataURLSuffix = (base64String) => {
    return base64String.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
  };

  //File upload
  const onSelectFile = (event) => {
    const selectedFiles = event.target.files;
    //Converting selectedFiles object into an array
    const selectedFilesArray = Array.from(selectedFiles);
    const base64Array = [];
    selectedFilesArray.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        base64Array.push(reader.result);
        //setting payload
        if (base64Array.length === selectedFilesArray.length) {
          const imagePayload = {
            uploadType: "VARIANT_IMAGES",
            images: {},
          };
          //storing image into payload with modified name
          base64Array.forEach((base64String, index) => {
            imagePayload.images[`image${index + 1}`] = removeDataURLSuffix(base64String);
          });
          //API to upload image
          uploadImageBase64(imagePayload)
            .then((res) => {
              const data = res?.data?.data?.data;
              if (data) {
                //Storing name of the file to display on UI when image is selected
                setUploadedImageName(selectedFilesArray[0].name);
                //storing the image url into state
                setImgaeUploaded(data?.image1);
              } else {
              }
            })
            .catch((err) => {});
        }
      };
      reader.onerror = (error) => {};
      reader.readAsDataURL(file);
    });
  };

  //Handling Modal
  const handleCancel = () => {
    setCancelAndConfirmModalOpen(true);
  };

  //For Fetching Menu
  useEffect(() => {
    const payload = {
      active: [true],
      page: 1,
      pageSize: 50,
      sourceId: [orgId],
      sourceLocationId: [locId],
    };
    filterCategory(payload)
      .then((response) => {
        const menuData = response?.data?.data?.results || [];
        setMenu(menuData);
      })
      .catch((error) => {
        showSnackbar(error.message || "Error in Fetching Menu");
      });
  }, [orgId, locId]);

  //Menu Options
  useEffect(() => {
    if (menu.length > 0) {
      const menuOptions = menu.map((item) => ({
        value: item.mainCategoryId,
        label: item.categoryName,
      }));
      setMenuOptions(menuOptions);
    }
  }, [menu]);

  const handleAgree = () => {
    setAgree((prev) => !prev);
  };

  //Handling sale modes
  const handleCheckValue = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setCheckedValue([...checkedValue, value]);
    } else {
      setCheckedValue(checkedValue?.filter((item) => item !== value));
    }
  };

  //Edit menu
  const handleEditMenu = (e) => {
    e.preventDefault();
    setLoader(true);

    updateRestaurantMenu(payload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          showSnackbar(
            res?.data?.data?.message || res?.data?.message || "Unable to update address",
            "error"
          );
          setLoader(false);
          return;
        }
        showSnackbar("Product updated successfully", "success");
        setLoader(false);
        navigate(-1);
      })
      .catch((err) => {
        showSnackbar(err || "Unable to update menu", "error");
        setLoader(false);
      });
  };

  // Initialize form with edit data
  useEffect(() => {
    if (editData) {
      const matchedTaxRate = gstSelectOptions.find(
        (option) => option.label === editData?.taxRate
      ) || { value: 0, label: "0%" };

      const matchedUOM = uomArray.find((option) => option.value === editData?.unitOfMeasure) || {
        value: "piece",
        label: "piece",
      };

      setProductCreationData({
        productName: editData.name || "",
        productTypes: editData.productTypes?.[0] || "MENU",
        foodType: editData.foodType || "",
        saleModes: {
          DINE_IN: {
            sellingPrice:
              editData.externalSalesChannels?.find(
                (channelName) => channelName.salesChannelName === "DINE_IN"
              )?.salePrice || "",
          },
          TAKE_AWAY: {
            sellingPrice:
              editData.externalSalesChannels?.find(
                (channelName) => channelName.salesChannelName === "TAKE_AWAY"
              )?.salePrice || "",
          },
          DELIVERY: {
            sellingPrice:
              editData.externalSalesChannels?.find(
                (channelName) => channelName.salesChannelName === "DELIVERY"
              )?.salePrice || "",
          },
        },
        taxRate: matchedTaxRate,
        cgst: matchedTaxRate.value / 2,
        sgst: matchedTaxRate.value / 2,
        specification: editData.specification || "",
        unitOfMeasure: matchedUOM,
        taxStatus: editData.taxStatus || "TAXABLE",
        veganType: editData.veganType || "",
        shortCode: editData.shortCode || "",
        taxType: editData.taxType || "INCLUSIVE",
      });
      setDietarySelected(editData.foodType || "");
      setIsVegan(editData.veganType ? String(editData.veganType) : "");
      setIsVeganDisplay(editData.foodType === "VEG");
      setSelectedMenuOption({
        value: editData.categoryLevel1Id || "",
        label: editData.categoryLevel1 || "",
      });
      setUploadedImageName(editData.imageUrl ? "" : "");
      setCheckedValue(
        ["DINE_IN", "TAKE_AWAY", "DELIVERY"].filter((mode) =>
          editData.externalSalesChannels?.some((channel) => channel?.salesChannelName === mode)
        )
      );
    }
  }, [editData, gstSelectOptions, uomArray]);

  return (
    <Navbar>
      <Box py={8} sx={{ width: "100%" }}>
        <Box className="createMenuContainer">
          <p className="createMenuHeading">{editData ? "Edit product" : "Add new product"}</p>
          <Box className="createMenuForm">
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4.5}>
                      <label htmlFor="productName" className="menuFieldHeading">
                        <PosCustomIcon image={itemNameIcon} height={"16px"} width={"16px"} />
                        Item Name<span className="mandatoryAstrike">*</span>
                      </label>
                      <input
                        placeholder="Enter Name"
                        type="text"
                        className={`menuInput ${editData ? "disableFields" : ""}`}
                        name="productName"
                        value={productCreationData.productName}
                        onChange={handleChange}
                        required
                        disabled={!!editData}
                      />
                      {validationError && (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                          {validationError.ItemName}
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} md={4.5}>
                      <label htmlFor="productName" className="menuFieldHeading">
                        <PosCustomIcon
                          icon={<CodeBracketIcon />}
                          color="#0860E6"
                          height={"16px"}
                          width={"16px"}
                        />
                        Item short code
                      </label>
                      <input
                        placeholder="Enter short code"
                        type="text"
                        className={`menuInput ${editData ? "disableFields" : ""}`}
                        name="shortCode"
                        value={productCreationData.shortCode}
                        onChange={handleChange}
                        maxLength="8"
                        disabled={!!editData}
                      />
                      {validationError && (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                          {validationError.shortCode}
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <div className="menuFieldHeading coverImageHeading">
                        <PosCustomIcon image={coverIcon} height={"16px"} width={"16px"} />
                        <p>Cover Image</p>
                      </div>
                      <input
                        type="file"
                        name="coverImage"
                        ref={fileInputRef}
                        multiple
                        accept="image/png , image/jpeg, image/webp"
                        style={{ display: "none" }}
                        onChange={onSelectFile}
                        disabled={!!editData}
                      />
                      <PosCustomButton
                        variant="white-h"
                        title="Browse or drop image"
                        border={true}
                        radius="4px"
                        width="100%"
                        p="12px 10px 12px 10px"
                        type="button"
                        onClickFunction={handleFileInputClick}
                        disabled={!!editData}
                      />
                      {uploadedImageName && (
                        <p style={{ fontSize: "0.75rem", color: "#E90000", fontWeight: 700 }}>
                          {uploadedImageName}
                        </p>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} className={editData ? "disableFields" : ""}>
                      <label htmlFor="menu" className="menuFieldHeading">
                        Category<span className="mandatoryAstrike">*</span>
                      </label>
                      <StyledSelect
                        onChange={(e) => handleSelectChange(e, "menu")}
                        value={selectedMenuOption}
                        options={menuOptions}
                        autoFocus={false}
                        className="menuDropdown"
                        placeholder="Enter"
                        isDisabled={!!editData}
                      />
                      {validationError && (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                          {validationError.category}
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <div className="menuFieldHeading">
                            <PosCustomIcon image={cutlery} height={"16px"} width={"16px"} />
                            <p>
                              Dietary Tags <span className="mandatoryAstrike">*</span>
                            </p>
                          </div>
                          <div className="flexingDietaryButtons">
                            <PosCustomRadioButton
                              id={"VEG"}
                              name={"foodType"}
                              value={"VEG"}
                              label={"Veg"}
                              variant={"green-d"}
                              radius={"4px"}
                              selectedValue={dietarySelected}
                              onSelect={(e) => {
                                setDietarySelected(e.target.value);
                                setIsVeganDisplay(true);
                              }}
                              disabled={!!editData}
                            />
                            <PosCustomRadioButton
                              id={"NON_VEG"}
                              name={"foodType"}
                              value={"NON_VEG"}
                              label={"Non veg"}
                              variant={"red-light"}
                              radius={"4px"}
                              selectedValue={dietarySelected}
                              onSelect={(e) => {
                                setDietarySelected(e.target.value);
                                setIsVeganDisplay(false);
                              }}
                              disabled={!!editData}
                            />
                            {validationError && (
                              <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                {validationError.dietary}
                              </p>
                            )}
                          </div>
                        </Grid>
                        {isVeganDisplay && (
                          <Grid item xs={12} md={6}>
                            <div className="menuFieldHeading">
                              <PosCustomIcon image={vegan} height={"16px"} width={"16px"} />
                              <p>Vegan</p>
                            </div>
                            <div className="flexingDietaryButtons">
                              <PosCustomRadioButton
                                id={"VEGANYES"}
                                name={"veganType"}
                                value={"true"}
                                label={"Yes"}
                                variant={"green-d"}
                                radius={"4px"}
                                selectedValue={isVegan}
                                onSelect={(e) => setIsVegan(e.target.value)}
                                disabled={!!editData}
                              />
                              <PosCustomRadioButton
                                id={"VEGANNO"}
                                name={"veganType"}
                                value={"false"}
                                label={"No"}
                                variant={"red-light"}
                                radius={"4px"}
                                selectedValue={isVegan}
                                onSelect={(e) => setIsVegan(e.target.value)}
                                disabled={!!editData}
                              />
                            </div>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Specification and UOM Fields */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <label htmlFor="specification" className="menuFieldHeading">
                        Specification
                      </label>
                      <input
                        placeholder="Enter Specification"
                        type="number"
                        step="any"
                        className="menuInput"
                        name="specification"
                        value={productCreationData.specification}
                        onChange={handleChange}
                        min="0"
                      />
                    </Grid>

                    <Grid item xs={12} md={6} mt={0.8}>
                      <label htmlFor="uom" className="menuFieldHeading">
                        Unit of Measure
                      </label>
                      <StyledSelect
                        onChange={(e) => handleSelectChange(e, "uom")}
                        value={productCreationData.unitOfMeasure}
                        options={uomArray}
                        autoFocus={false}
                        className="menuDropdown"
                        placeholder="Select UOM"
                      />
                    </Grid>
                  </Grid>

                  <p className="menuFieldHeading">
                    <PosCustomIcon image={rupeesIcon} height={"16px"} width={"16px"} />
                    Sale details<span className="mandatoryAstrike">*</span>
                  </p>

                  {saleModeArr.map((item) => (
                    <Grid container spacing={2} key={item.saleMode}>
                      <Grid item xs={12} md={2}>
                        <div className="saleModeSelection">
                          <PosCustomCheckBox
                            id={item?.saleMode}
                            name={"saleMode"}
                            value={item?.saleMode}
                            label={item?.label}
                            checkedValue={checkedValue}
                            onCheck={handleCheckValue}
                            defaultIcon={false}
                            iconOnRight
                            fontSize={"0.813rem"}
                            fontWeight={700}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <div className="saleDetailLeftContainer">
                          <div style={{ width: "100%" }}>
                            <label htmlFor="productName">
                              Item Price<span className="mandatoryAstrike">*</span>
                            </label>
                            <input
                              placeholder="Enter"
                              type="number"
                              className="menuSubInput"
                              name="sellingPrice"
                              value={productCreationData?.saleModes[item.saleMode]?.sellingPrice}
                              onChange={(e) => handleChange(e, item.saleMode)}
                              required
                              disabled={checkedValue.includes(item.saleMode) ? false : true}
                            />
                            {validationError && (
                              <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                {validationError.itemPrice}
                              </p>
                            )}
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  ))}

                  {/* Tax Type Field */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <div className="menuFieldHeading">
                        <p>Tax Type</p>
                      </div>
                      <div className="flexingDietaryButtons">
                        <PosCustomRadioButton
                          id={"INCLUSIVE"}
                          name={"taxType"}
                          value={"INCLUSIVE"}
                          label={"Inclusive"}
                          variant={"green-d"}
                          radius={"4px"}
                          selectedValue={productCreationData.taxType}
                          onSelect={(e) =>
                            setProductCreationData((prev) => ({
                              ...prev,
                              taxType: e.target.value,
                            }))
                          }
                        />
                        <PosCustomRadioButton
                          id={"EXCLUSIVE"}
                          name={"taxType"}
                          value={"EXCLUSIVE"}
                          label={"Exclusive"}
                          variant={"red-light"}
                          radius={"4px"}
                          selectedValue={productCreationData.taxType}
                          onSelect={(e) =>
                            setProductCreationData((prev) => ({
                              ...prev,
                              taxType: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={9}>
                      <div style={{ width: "100%" }} className={editData ? "disableFields" : ""}>
                        <label htmlFor="gstMenu">GST</label>
                        <StyledSelect
                          onChange={(e) => handleSelectChange(e, "gst")}
                          value={productCreationData?.taxRate}
                          options={gstSelectOptions}
                          className="menuDropdown"
                          autoFocus={false}
                          isDisabled={!!editData}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <label>CGST(%)</label>
                          <input
                            placeholder="Enter"
                            type="number"
                            className="menuSubInput"
                            name="cgst"
                            value={productCreationData?.cgst}
                            readOnly
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <label>SGST(%)</label>
                          <input
                            placeholder="Enter"
                            type="number"
                            className="menuSubInput"
                            name="sgst"
                            value={productCreationData?.sgst}
                            readOnly
                          />
                        </Grid>
                        <Grid item xs={12} md={4}></Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <div className="consent">
                <PosCustomCheckBox
                  id="something"
                  name={"agree"}
                  value={"checked"}
                  label={
                    "Item added through this method will only be available for sale in restaurant and will go and sit in approval flow in RMS"
                  }
                  checkedValue={agree ? ["checked"] : []}
                  defaultIcon={false}
                  iconOnLeft
                  checkBoxColor={"#212121"}
                  checkMarkColor={"#FFFFFF"}
                  onCheck={handleAgree}
                />
              </div>
              <div className="menuCreationButtonContainer">
                <PosCustomButton
                  variant={"black-s"}
                  title="Cancel"
                  type="button"
                  radius="4px"
                  p={"8px 24px 8px 24px"}
                  onClickFunction={handleCancel}
                />
                <PosCustomButton
                  variant={"blue-d"}
                  title={editData ? "Update" : "Submit"}
                  radius="4px"
                  p={"8px 24px 8px 24px"}
                  type={editData ? "button" : "submit"}
                  disabled={!agree}
                  onClickFunction={editData ? handleEditMenu : handleSubmit}
                  loading={loader}
                />
              </div>
            </form>
            <CancelAndConfirmModal
              cancelAndConfirmModalOpen={cancelAndConfirmModalOpen}
              setCancelAndConfirmModalOpen={setCancelAndConfirmModalOpen}
              cancelTitle={"Yes, cancel"}
              confirmTitle={"Keep editing"}
            />
          </Box>
        </Box>
      </Box>
    </Navbar>
  );
};
